interface AttributionPillProps {
  /** Provider attribution string (allowed HTML: anchor tags). */
  attribution: string
}

/**
 * Tiny floating attribution chip in the bottom-right of the map. Replaces
 * MapLibre's stock AttributionControl so the credit line stays in-brand and
 * doesn't render as a stretched ribbon when the basemap CSS lags behind.
 *
 * The string is provider-supplied and contains anchor tags only (no inline
 * scripts), which we render via dangerouslySetInnerHTML — safe because the
 * value comes from our own provider modules under `src/lib/map/`, not user
 * input.
 */
export function AttributionPill({ attribution }: AttributionPillProps) {
  return (
    <div
      // Hidden below sm — the ResultsPanel sits in the bottom-right on
      // mobile and overlaps the attribution pill anyway, so the pill
      // adds no value there. Desktop (sm+) still shows it, keeping the
      // provider credit visible on the canonical viewing surface.
      className={[
        'hidden sm:inline-flex',
        'absolute left-5 bottom-3 z-10',
        'items-center',
        'px-2.5 py-1 rounded-full',
        'bg-[var(--color-elev-strong)] backdrop-blur-[14px]',
        'border border-[var(--color-border)]',
        'font-[var(--font-mono)] text-[10px] text-[var(--color-muted)]',
        'transition-colors duration-200',
        '[&_a]:text-[var(--color-text)] [&_a]:opacity-90 [&_a]:hover:opacity-100 [&_a]:underline-offset-2',
      ].join(' ')}
      dangerouslySetInnerHTML={{ __html: attribution }}
    />
  )
}
